module.exports = __webpack_public_path__ + "img/aboutEMA.b12df895.jpg";